import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import { FormLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SaveButton from '../Common/SaveButton';
import { useAsyncCallback } from '../../hooks/useAsyncCallback';

export default function ConfirmDeleteDialogHazard (props) {
    const { onClose, open, deleteTitle, deleteLabel } = props;
    const { t } = useTranslation();

    const handleCancel = () => {
        onClose(false);
    };

    const { run: handleOk, loading: saving } = useAsyncCallback(async () => {
        await onClose(true);
    });

    const getDialogTitle = () => {
        return deleteTitle || t('common.confirmDelete');
    };

    const getDeleteLabel = () => {
        return deleteLabel || t('common.confirmDeleteDefault');
    };

    return (
        <Dialog
            sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
            maxWidth="xs"
            open={open}
        >
            <DialogTitle>{getDialogTitle()}</DialogTitle>
            <DialogContent dividers>
                <FormLabel>{getDeleteLabel()}</FormLabel>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleCancel} disabled={saving}>
                    {t('common.cancel')}
                </Button>
                <SaveButton loading={saving} onClick={handleOk} color="error">
                    {t('common.delete')}
                </SaveButton>
            </DialogActions>
        </Dialog>
    );
}

ConfirmDeleteDialogHazard.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    deleteTitle: PropTypes.string.isRequired,
    deleteLabel: PropTypes.string.isRequired,
};
